import { render, staticRenderFns } from "./PdrbChartDonut.vue?vue&type=template&id=1704ea63&scoped=true"
import script from "./PdrbChartDonut.vue?vue&type=script&lang=js"
export * from "./PdrbChartDonut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1704ea63",
  null
  
)

export default component.exports